import { lazy } from 'react';
import { D as DefaultTranslationComp } from './en-US-eYvf6UDF.js';

/* eslint-disable quotes, quote-props, comma-dangle, max-len */
// eslint-disable-next-line @typescript-eslint/no-unused-vars

const translationImports = {
  'ar-AE': () => import(/* webpackChunkName: "storm-ui--ChatBoxInput--ar-AE" */'./ar-AE-BjD0lcNo.js'),
  'de-DE': () => import(/* webpackChunkName: "storm-ui--ChatBoxInput--de-DE" */'./de-DE-DxXc3p3u.js'),
  'en-AU': () => import(/* webpackChunkName: "storm-ui--ChatBoxInput--en-AU" */'./en-AU-uYakHTmT.js'),
  'en-CA': () => import(/* webpackChunkName: "storm-ui--ChatBoxInput--en-CA" */'./en-CA-B7t3JQ0b.js'),
  'en-GB': () => import(/* webpackChunkName: "storm-ui--ChatBoxInput--en-GB" */'./en-GB-DoI4OZQ3.js'),
  'en-IN': () => import(/* webpackChunkName: "storm-ui--ChatBoxInput--en-IN" */'./en-IN-DWalxKy3.js'),
  'en-SG': () => import(/* webpackChunkName: "storm-ui--ChatBoxInput--en-SG" */'./en-SG-fh3WiST2.js'),
  'es-CO': () => import(/* webpackChunkName: "storm-ui--ChatBoxInput--es-CO" */'./es-CO-DhCUoQPR.js'),
  'es-ES': () => import(/* webpackChunkName: "storm-ui--ChatBoxInput--es-ES" */'./es-ES-CO8jntCe.js'),
  'es-MX': () => import(/* webpackChunkName: "storm-ui--ChatBoxInput--es-MX" */'./es-MX-CafklhEP.js'),
  'es-US': () => import(/* webpackChunkName: "storm-ui--ChatBoxInput--es-US" */'./es-US-BT2c4UZe.js'),
  'fr-CA': () => import(/* webpackChunkName: "storm-ui--ChatBoxInput--fr-CA" */'./fr-CA-RGD4s5ae.js'),
  'fr-FR': () => import(/* webpackChunkName: "storm-ui--ChatBoxInput--fr-FR" */'./fr-FR-DImK1Wbk.js'),
  'hi-IN': () => import(/* webpackChunkName: "storm-ui--ChatBoxInput--hi-IN" */'./hi-IN-BeFyHQuI.js'),
  'it-IT': () => import(/* webpackChunkName: "storm-ui--ChatBoxInput--it-IT" */'./it-IT-CPWgM027.js'),
  'ja-JP': () => import(/* webpackChunkName: "storm-ui--ChatBoxInput--ja-JP" */'./ja-JP-_SxYLksH.js'),
  'ko-KR': () => import(/* webpackChunkName: "storm-ui--ChatBoxInput--ko-KR" */'./ko-KR-62lY7lLA.js'),
  'nl-NL': () => import(/* webpackChunkName: "storm-ui--ChatBoxInput--nl-NL" */'./nl-NL-DAfEP2x5.js'),
  'pl-PL': () => import(/* webpackChunkName: "storm-ui--ChatBoxInput--pl-PL" */'./pl-PL-BUgnejR4.js'),
  'pt-BR': () => import(/* webpackChunkName: "storm-ui--ChatBoxInput--pt-BR" */'./pt-BR-4wKVCnM5.js'),
  'sv-SE': () => import(/* webpackChunkName: "storm-ui--ChatBoxInput--sv-SE" */'./sv-SE-BRDq0_CL.js'),
  'ta-IN': () => import(/* webpackChunkName: "storm-ui--ChatBoxInput--ta-IN" */'./ta-IN-Bu6drBJD.js'),
  'th-TH': () => import(/* webpackChunkName: "storm-ui--ChatBoxInput--th-TH" */'./th-TH-ttKmmJT8.js'),
  'tr-TR': () => import(/* webpackChunkName: "storm-ui--ChatBoxInput--tr-TR" */'./tr-TR-A9DeJYdF.js'),
  'vi-VN': () => import(/* webpackChunkName: "storm-ui--ChatBoxInput--vi-VN" */'./vi-VN-DufmSK2o.js'),
  'zh-CN': () => import(/* webpackChunkName: "storm-ui--ChatBoxInput--zh-CN" */'./zh-CN-Cz6UU3aI.js'),
  'zh-TW': () => import(/* webpackChunkName: "storm-ui--ChatBoxInput--zh-TW" */'./zh-TW-6vXn6Wfh.js')
};
const translationComps = Object.entries(translationImports).reduce((acc, [localCode, importFn]) => ({
  ...acc,
  [localCode]: /*#__PURE__*/lazy(importFn)
}), {});
function getTranslationComponent(locale) {
  return {
    component: locale && locale in translationComps ? translationComps[locale] : DefaultTranslationComp,
    locale: locale && locale in translationComps ? locale : 'en-US',
    translationImports
  };
}

export { getTranslationComponent as g };
//# sourceMappingURL=index-BxB2jbOV.js.map
